import React from 'react';
import Map from './Map';
// You can see config.json after running `npm start` or `npm run build`
import './App.css';

function App() {

  return (
    <div className="App">
      <Map/>
    </div>
  );
}

export default App;
